import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { I18nextProvider } from 'react-i18next';

import { isApiClientError } from '@sm/api';

import { TooltipProvider } from './components/ui/Menu';
import { i18n } from './lib/i18n';
import { bindUserContext, onMutationError, onQueryError } from './lib/observability';
import { createAppRouter } from './router';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    // Sentry: samo mreža i 5xx (ne 4xx validacija); bez efekta kad Sentry nije uključen.
    queryCache: new QueryCache({ onError: onQueryError }),
    mutationCache: new MutationCache({ onError: onMutationError }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (count, error) => {
          if (isApiClientError(error) && error.status >= 400 && error.status < 500) return false;
          return count < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}

const queryClient = createQueryClient();
bindUserContext(queryClient);
const router = createAppRouter(queryClient);

export function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={250}>
          <RouterProvider router={router} />
        </TooltipProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}
